import { adultHomeTiles, type AdultHomePrefs, type AdultHomeProfile } from '../lib/adultHomePrefs'

export function AdultHomeCustomizer({ profile, prefs, onToggle, onMove, onRestore }: {
  profile: AdultHomeProfile
  prefs: AdultHomePrefs
  onToggle: (id: string) => void
  onMove: (id: string, direction: -1 | 1) => void
  onRestore: () => void
}) {
  const tiles = adultHomeTiles[profile]
  return <section className="mt-3 rounded-2xl border border-[#c7d9eb] bg-white p-4 text-slate-900 shadow-[0_8px_24px_rgba(35,78,126,.07)]">
    <h2 className="text-base font-black text-[#172640]">Choose your Home tiles</h2>
    <p className="mt-1 text-xs text-slate-600">Switch tiles off to move them to More. Use the arrows to set their order. Open the Calendar tab for your full calendar.</p>
    <div className="mt-3 grid gap-2">{prefs.order.map((id, index) => {
      const tile = tiles.find(item => item.id === id)
      if (!tile) return null
      return <div key={id} className="flex items-center gap-2 rounded-xl bg-[#f6f9fc] p-2">
        <label className="flex min-w-0 flex-1 items-center gap-2 text-xs font-bold text-slate-800"><input type="checkbox" checked={prefs.visible.includes(id)} onChange={() => onToggle(id)} aria-label={`Show ${tile.label} on Home`}/><span>{tile.label}</span></label>
        <button type="button" onClick={() => onMove(id, -1)} disabled={index === 0} aria-label={`Move ${tile.label} up`} className="h-9 w-9 shrink-0 rounded-lg bg-white font-bold disabled:opacity-25">↑</button>
        <button type="button" onClick={() => onMove(id, 1)} disabled={index === prefs.order.length - 1} aria-label={`Move ${tile.label} down`} className="h-9 w-9 shrink-0 rounded-lg bg-white font-bold disabled:opacity-25">↓</button>
      </div>
    })}</div>
    <button type="button" onClick={onRestore} className="mt-3 text-xs font-bold text-[#607f9e]">Restore all tiles</button>
  </section>
}
